import React, { useEffect, useState } from 'react';
import algoliasearch from 'algoliasearch/lite';
import { InstantSearch, Configure } from 'react-instantsearch';
import SearchBox from './components/SearchBox';
import StateResults from './components/StateResults';
import SeeAllResults from './components/SeeAllResults';
import NoResults from './components/NoResults';
import { init } from './helpers/overlay-toggle';

init();

const algoliaClient = algoliasearch(process.env.ALGOLIA_APP_ID, window.algolia.key);

const searchClient = {
    ...algoliaClient,
    search(requests) {
        const newRequests = requests.map((request) => {
            // test for empty string and change request parameter: analytics
            if (!request.params.query || request.params.query.length === 0) {
                request.params.analytics = false;
            }
            return request;
        });
        return algoliaClient.search(newRequests);
    },
};

const SearchOverlay = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const onGlobalSearchOpen = () => {
            setIsOpen(true);
        };

        const onGlobalSearchClose = () => {
            setIsOpen(false);
        };

        document.addEventListener('search-overlay-open', () => onGlobalSearchOpen());
        document.addEventListener('search-overlay-close', () => onGlobalSearchClose());

        return () => {
            document.removeEventListener('search-overlay-open', onGlobalSearchOpen);
            document.removeEventListener('search-overlay-close', onGlobalSearchClose);
        };
    }, []);

    if (!isOpen) {
        return null;
    }

    return (
        <InstantSearch
            insights={{
                insightsInitParams: {
                    useCookie: true,
                },
            }}
            searchClient={searchClient}
            indexName={`${process.env.ENVIRONMENT}_all`}
        >
            <Configure hitsPerPage={3} />
            <div className="searchDrawer">
                <div className="searchDrawer__wrap">
                    <SearchBox />
                    <div style={{ marginTop: '40px' }}>
                        <StateResults />
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <SeeAllResults />
                            <NoResults />
                        </div>
                    </div>
                </div>
            </div>
        </InstantSearch>
    );
};

export default SearchOverlay;
